import {command, query, queryAll, queryOne, querySearch} from "../utils/api";

const COMMAND_BASE_URL = `${process.env.PUBLIC_URL}/api/v1/product/`;

const DELETE_PRODUCT_URL = `${process.env.PUBLIC_URL}/api/v1/product/deleteProduct`;
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const DELETE_PRODUCT_COMPLETED = 'DELETE_PRODUCT_COMPLETED';
export const DELETE_PRODUCT_FAILED = 'DELETE_PRODUCT_FAILED';
export const deleteProduct = command(DELETE_PRODUCT_URL, DELETE_PRODUCT, DELETE_PRODUCT_COMPLETED, DELETE_PRODUCT_FAILED);

export const SHOW_DELETE_PRODUCT_MODAL = 'SHOW_DELETE_PRODUCT_MODAL';
export function showDeleteProductModal(product) {
  return {type: SHOW_DELETE_PRODUCT_MODAL, payload: product};
}

export const HIDE_DELETE_PRODUCT_MODAL = 'HIDE_DELETE_PRODUCT_MODAL';
export function hideDeleteProductModal() {
  return {type: HIDE_DELETE_PRODUCT_MODAL};
}

const SEARCH_PRODUCTS_URL = `${process.env.PUBLIC_URL}/api/v1/product/searchProduct`;

function mapTermToSearchFilter(term) {
  return {
    or: [
      {brandName: {ilike: `%${term}%`}},
      {categoryName: {ilike: `%${term}%`}},
      {display: {ilike: `%${term}%`}},
      {supplierName: {ilike: `%${term}%`}},
      {description: {ilike: `%${term}%`}},
    ]
  };
}

export const SEARCH_PRODUCTS = 'SEARCH_PRODUCTS';
export const SEARCH_PRODUCTS_COMPLETED = 'SEARCH_PRODUCTS_COMPLETED';
export const SEARCH_PRODUCTS_FAILED = 'SEARCH_PRODUCTS_FAILED';
export const searchProducts = querySearch(SEARCH_PRODUCTS_URL, SEARCH_PRODUCTS, SEARCH_PRODUCTS_COMPLETED,
  SEARCH_PRODUCTS_FAILED, null, {filters: {archived: false}});
export const searchArchivedProducts = querySearch(SEARCH_PRODUCTS_URL, SEARCH_PRODUCTS, SEARCH_PRODUCTS_COMPLETED,
  SEARCH_PRODUCTS_FAILED, null, {filters: {archived: true}});

const GET_PRODUCTS_URL = `${process.env.PUBLIC_URL}/api/v1/r/products`;

export const GET_PRODUCTS = 'GET_PRODUCTS';
export const GET_PRODUCTS_COMPLETED = 'GET_PRODUCTS_COMPLETED';
export const GET_PRODUCTS_FAILED = 'GET_PRODUCTS_FAILED';
export function getProducts({salonId, supplierId, filter, units}) {
  const queryFilter = {
    where: {
      and: [
        {salonId: {eq: salonId}},
      ],
    },
    order: "name ASC"
  };
  if (supplierId) {
    queryFilter.where.and.push({supplierId: {eq: supplierId}});
  }
  if (filter && filter.length) {
    const terms = filter.split(' ');
    queryFilter.where.and = queryFilter.where.and
      .concat(terms.map(mapTermToSearchFilter));
  }
  if (units && units.length) {
    queryFilter.where.and.push({unit: {inq: units}});
  }
  return queryAll(GET_PRODUCTS_URL, queryFilter, GET_PRODUCTS, GET_PRODUCTS_COMPLETED, GET_PRODUCTS_FAILED);
}

export const GET_PRODUCT = 'GET_PRODUCT';
export const GET_PRODUCT_COMPLETED = 'GET_PRODUCT_COMPLETED';
export const GET_PRODUCT_FAILED = 'GET_PRODUCT_FAILED';
export function getProduct({productId}) {
  return queryOne(GET_PRODUCTS_URL, {where:{productId}}, GET_PRODUCT, GET_PRODUCT_COMPLETED, GET_PRODUCT_FAILED);
}

const GET_PRODUCT_TO_REORDER_LIST_URL = `${process.env.PUBLIC_URL}/api/v1/r/productsToOrder`;

export const GET_PRODUCT_TO_REORDER_LIST = 'GET_PRODUCT_TO_REORDER_LIST';
export const GET_PRODUCT_TO_REORDER_LIST_COMPLETED = 'GET_PRODUCT_TO_REORDER_LIST_COMPLETED';
export const GET_PRODUCT_TO_REORDER_LIST_FAILED = 'GET_PRODUCT_TO_REORDER_LIST_FAILED';
export function getProductToReorderList({salonId, supplierId, order, pagination}) {
  const filter = {
    where: {salonId: {eq: salonId}},
    order,
  };
  if (supplierId) {
    filter.where.supplierId = {eq: supplierId};
  }
  return query(GET_PRODUCT_TO_REORDER_LIST_URL, filter, GET_PRODUCT_TO_REORDER_LIST,
    GET_PRODUCT_TO_REORDER_LIST_COMPLETED, GET_PRODUCT_TO_REORDER_LIST_FAILED, pagination);
}

const GET_STOCKS_URL = `${process.env.PUBLIC_URL}/api/v1/r/stocks`;
export const GET_PRODUCT_STOCKS = 'GET_PRODUCT_STOCKS';
export const GET_PRODUCT_STOCKS_COMPLETED = 'GET_PRODUCT_STOCKS_COMPLETED';
export const GET_PRODUCT_STOCKS_FAILED = 'GET_PRODUCT_STOCKS_FAILED';
export function getProductStocks({productId}) {
  return queryAll(GET_STOCKS_URL, {where: {productId}}, GET_PRODUCT_STOCKS, GET_PRODUCT_STOCKS_COMPLETED,
    GET_PRODUCT_STOCKS_FAILED);
}

export const GET_PRODUCT_STOCK = 'GET_PRODUCT_STOCK';
export const GET_PRODUCT_STOCK_COMPLETED = 'GET_PRODUCT_STOCK_COMPLETED';
export const GET_PRODUCT_STOCK_FAILED = 'GET_PRODUCT_STOCK_FAILED';
export function getProductStock({productId, sku}) {
  return queryOne(GET_STOCKS_URL, {where: {productId, sku}}, GET_PRODUCT_STOCK, GET_PRODUCT_STOCK_COMPLETED,
    GET_PRODUCT_STOCK_FAILED);
}

export const SEARCH_PRODUCT_STOCKS = 'SEARCH_PRODUCT_STOCKS';
export const SEARCH_PRODUCT_STOCKS_COMPLETED = 'SEARCH_PRODUCT_STOCKS_COMPLETED';
export const SEARCH_PRODUCT_STOCKS_FAILED = 'SEARCH_PRODUCT_STOCKS_FAILED';
export const searchProductStocks = querySearch(GET_STOCKS_URL, SEARCH_PRODUCT_STOCKS, SEARCH_PRODUCT_STOCKS_COMPLETED,
  SEARCH_PRODUCT_STOCKS_FAILED, ['sku', 'lotNumber']);

const GET_PRODUCT_HISTORY_URL = `${process.env.PUBLIC_URL}/api/v1/r/productHistory`;
export const SEARCH_PRODUCT_HISTORY = 'SEARCH_PRODUCT_HISTORY';
export const SEARCH_PRODUCT_HISTORY_COMPLETED = 'SEARCH_PRODUCT_HISTORY_COMPLETED';
export const SEARCH_PRODUCT_HISTORY_FAILED = 'SEARCH_PRODUCT_HISTORY_FAILED';
export const searchProductHistory = querySearch(GET_PRODUCT_HISTORY_URL, SEARCH_PRODUCT_HISTORY,
  SEARCH_PRODUCT_HISTORY_COMPLETED, SEARCH_PRODUCT_HISTORY_FAILED, ['description', 'sku'],
  {defaultOrder: 'createdAt DESC'});

const GET_BATCHES_URL = `${process.env.PUBLIC_URL}/api/v1/r/stockBatches`;
export const SEARCH_PRODUCT_STOCK_BATCHES = 'SEARCH_PRODUCT_STOCK_BATCHES';
export const SEARCH_PRODUCT_STOCK_BATCHES_COMPLETED = 'SEARCH_PRODUCT_STOCK_BATCHES_COMPLETED';
export const SEARCH_PRODUCT_STOCK_BATCHES_FAILED = 'SEARCH_PRODUCT_STOCK_BATCHES_FAILED';
export const searchProductStockBatches = querySearch(GET_BATCHES_URL, SEARCH_PRODUCT_STOCK_BATCHES,
  SEARCH_PRODUCT_STOCK_BATCHES_COMPLETED, SEARCH_PRODUCT_STOCK_BATCHES_FAILED, ['sku', 'receivedAt'],
  {defaultOrder: 'receivedAt DESC'});

export const GET_PRODUCT_STOCK_BATCH = 'GET_PRODUCT_STOCK_BATCH';
export const GET_PRODUCT_STOCK_BATCH_COMPLETED = 'GET_PRODUCT_STOCK_BATCH_COMPLETED';
export const GET_PRODUCT_STOCK_BATCH_FAILED = 'GET_PRODUCT_STOCK_BATCH_FAILED';
export function getProductStockBatch({productId, sku, receivedAt}) {
  return queryOne(GET_BATCHES_URL, {where: {productId, sku, receivedAt}}, GET_PRODUCT_STOCK_BATCH,
    GET_PRODUCT_STOCK_BATCH_COMPLETED, GET_PRODUCT_STOCK_BATCH_FAILED);
}

const ADD_PRODUCT_URL = `${process.env.PUBLIC_URL}/api/v1/product/addProduct`;
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const ADD_PRODUCT_COMPLETED = 'ADD_PRODUCT_COMPLETED';
export const ADD_PRODUCT_FAILED = 'ADD_PRODUCT_FAILED';
export const addProduct = command(ADD_PRODUCT_URL, ADD_PRODUCT, ADD_PRODUCT_COMPLETED, ADD_PRODUCT_FAILED);

const CHANGE_PRODUCT_SALEPRICE_URL = `${process.env.PUBLIC_URL}/api/v1/product/changeProductSalePrice`;
export const CHANGE_PRODUCT_SALEPRICE = 'CHANGE_PRODUCT_SALEPRICE';
export const CHANGE_PRODUCT_SALEPRICE_COMPLETED = 'CHANGE_PRODUCT_SALEPRICE_COMPLETED';
export const CHANGE_PRODUCT_SALEPRICE_FAILED = 'CHANGE_PRODUCT_SALEPRICE_FAILED';
export const changeProductSalePrice = command(CHANGE_PRODUCT_SALEPRICE_URL, CHANGE_PRODUCT_SALEPRICE,
  CHANGE_PRODUCT_SALEPRICE_COMPLETED, CHANGE_PRODUCT_SALEPRICE_FAILED);

const RECEIVE_PRODUCT_URL = `${process.env.PUBLIC_URL}/api/v1/product/receiveProduct`;
export const RECEIVE_PRODUCT = 'RECEIVE_PRODUCT';
export const RECEIVE_PRODUCT_COMPLETED = 'RECEIVE_PRODUCT_COMPLETED';
export const RECEIVE_PRODUCT_FAILED = 'RECEIVE_PRODUCT_FAILED';
export const receiveProduct = command(RECEIVE_PRODUCT_URL, RECEIVE_PRODUCT, RECEIVE_PRODUCT_COMPLETED,
  RECEIVE_PRODUCT_FAILED);

const ADJUST_PRODUCT_URL = `${process.env.PUBLIC_URL}/api/v1/product/adjustProduct`;
export const ADJUST_PRODUCT = 'ADJUST_PRODUCT';
export const ADJUST_PRODUCT_COMPLETED = 'ADJUST_PRODUCT_COMPLETED';
export const ADJUST_PRODUCT_FAILED = 'ADJUST_PRODUCT_FAILED';
export const adjustProduct = command(ADJUST_PRODUCT_URL, ADJUST_PRODUCT, ADJUST_PRODUCT_COMPLETED,
  ADJUST_PRODUCT_FAILED);

const UPDATE_PRODUCT_URL = `${process.env.PUBLIC_URL}/api/v1/product/updateProduct`;
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const UPDATE_PRODUCT_COMPLETED = 'UPDATE_PRODUCT_COMPLETED';
export const UPDATE_PRODUCT_FAILED = 'UPDATE_PRODUCT_FAILED';
export const updateProduct = command(UPDATE_PRODUCT_URL, UPDATE_PRODUCT, UPDATE_PRODUCT_COMPLETED,
  UPDATE_PRODUCT_FAILED);

const GENERATE_BARCODE_URL = `${process.env.PUBLIC_URL}/api/v1/product/generateBarcode`;
export const GENERATE_BARCODE = 'GENERATE_BARCODE';
export const GENERATE_BARCODE_COMPLETED = 'GENERATE_BARCODE_COMPLETED';
export const GENERATE_BARCODE_FAILED = 'GENERATE_BARCODE_FAILED';
export const generateBarcode = command(GENERATE_BARCODE_URL, GENERATE_BARCODE, GENERATE_BARCODE_COMPLETED,
  GENERATE_BARCODE_FAILED);

export const CORRECT_RECEIVED_PRODUCT = 'CORRECT_RECEIVED_PRODUCT';
export const CORRECT_RECEIVED_PRODUCT_COMPLETED = 'CORRECT_RECEIVED_PRODUCT_COMPLETED';
export const CORRECT_RECEIVED_PRODUCT_FAILED = 'CORRECT_RECEIVED_PRODUCT_FAILED';
export const correctReceivedProduct = command(COMMAND_BASE_URL + 'correctReceivedProduct',
  CORRECT_RECEIVED_PRODUCT, CORRECT_RECEIVED_PRODUCT_COMPLETED, CORRECT_RECEIVED_PRODUCT_FAILED);

const SELL_PRODUCT_URL = `${process.env.PUBLIC_URL}/api/v1/product/sellProduct`;
export const SELL_PRODUCT = 'SELL_PRODUCT';
export const SELL_PRODUCT_COMPLETED = 'SELL_PRODUCT_COMPLETED';
export const SELL_PRODUCT_FAILED = 'SELL_PRODUCT_FAILED';
export const sellProduct = command(SELL_PRODUCT_URL, SELL_PRODUCT, SELL_PRODUCT_COMPLETED,
  SELL_PRODUCT_FAILED);

export const SET_SUPPLIER_TO_REORDER = 'SET_SUPPLIER_TO_REORDER';
export function setSupplierToReorder(supplierId) {
  return {
    type: SET_SUPPLIER_TO_REORDER,
    payload: {
      supplierId
    }
  };
}

const GET_PRODUCTS_SOLD_URL = `${process.env.PUBLIC_URL}/api/v1/r/productsSold`;
export const SEARCH_PRODUCTS_SOLD = 'SEARCH_PRODUCTS_SOLD';
export const SEARCH_PRODUCTS_SOLD_COMPLETED = 'SEARCH_PRODUCTS_SOLD_COMPLETED';
export const SEARCH_PRODUCTS_SOLD_FAILED = 'SEARCH_PRODUCTS_SOLD_FAILED';
export const searchProductsSold = querySearch(GET_PRODUCTS_SOLD_URL, SEARCH_PRODUCTS_SOLD,
  SEARCH_PRODUCTS_SOLD_COMPLETED, SEARCH_PRODUCTS_SOLD_FAILED, ['productDisplay', 'sku', 'soldAt'],
  {defaultOrder: 'soldAt DESC'});

const ADJUST_NEGATIVE_PRODUCTS_TO_ZERO_URL = `${process.env.PUBLIC_URL}/api/v1/product/adjustNegativesToZero`;
export const ADJUST_NEGATIVE_PRODUCTS_TO_ZERO = 'ADJUST_NEGATIVE_PRODUCTS_TO_ZERO';
export const ADJUST_NEGATIVE_PRODUCTS_TO_ZERO_COMPLETED = 'ADJUST_NEGATIVE_PRODUCTS_TO_ZERO_COMPLETED';
export const ADJUST_NEGATIVE_PRODUCTS_TO_ZERO_FAILED = 'ADJUST_NEGATIVE_PRODUCTS_TO_ZERO_FAILED';
export const adjustNegativeProductsToZero = command(ADJUST_NEGATIVE_PRODUCTS_TO_ZERO_URL,
  ADJUST_NEGATIVE_PRODUCTS_TO_ZERO, ADJUST_NEGATIVE_PRODUCTS_TO_ZERO_COMPLETED,
  ADJUST_NEGATIVE_PRODUCTS_TO_ZERO_FAILED);

const ARCHIVE_PRODUCT_URL = `${process.env.PUBLIC_URL}/api/v1/product/archiveProduct`;
export const ARCHIVE_PRODUCT = 'ARCHIVE_PRODUCT';
export const ARCHIVE_PRODUCT_COMPLETED = 'ARCHIVE_PRODUCT_COMPLETED';
export const ARCHIVE_PRODUCT_FAILED = 'ARCHIVE_PRODUCT_FAILED';
export const archiveProduct = command(ARCHIVE_PRODUCT_URL, ARCHIVE_PRODUCT, ARCHIVE_PRODUCT_COMPLETED,
  ARCHIVE_PRODUCT_FAILED);

const RESTORE_PRODUCT_URL = `${process.env.PUBLIC_URL}/api/v1/product/restoreProduct`;
export const RESTORE_PRODUCT = 'RESTORE_PRODUCT';
export const RESTORE_PRODUCT_COMPLETED = 'RESTORE_PRODUCT_COMPLETED';
export const RESTORE_PRODUCT_FAILED = 'RESTORE_PRODUCT_FAILED';
export const restoreProduct = command(RESTORE_PRODUCT_URL, RESTORE_PRODUCT, RESTORE_PRODUCT_COMPLETED,
  RESTORE_PRODUCT_FAILED);

const RETURN_PRODUCT_URL = `${process.env.PUBLIC_URL}/api/v1/product/returnProduct`;
export const RETURN_PRODUCT = 'RETURN_PRODUCT';
export const RETURN_PRODUCT_COMPLETED = 'RETURN_PRODUCT_COMPLETED';
export const RETURN_PRODUCT_FAILED = 'RETURN_PRODUCT_FAILED';
export const returnProduct = command(RETURN_PRODUCT_URL, RETURN_PRODUCT, RETURN_PRODUCT_COMPLETED,
  RETURN_PRODUCT_FAILED);



// WEBPACK FOOTER //
// ./src/Product/actions.js